import { render, staticRenderFns } from "./MainTableNine.vue?vue&type=template&id=044f37b9&scoped=true&"
import script from "./MainTableNine.vue?vue&type=script&lang=js&"
export * from "./MainTableNine.vue?vue&type=script&lang=js&"
import style0 from "./MainTableNine.vue?vue&type=style&index=0&id=044f37b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f37b9",
  null
  
)

export default component.exports